import { render } from "./ParkingVehicleGet.vue?vue&type=template&id=276d0848&scoped=true"
import script from "./ParkingVehicleGet.vue?vue&type=script&lang=js"
export * from "./ParkingVehicleGet.vue?vue&type=script&lang=js"

import "./ParkingVehicleGet.vue?vue&type=style&index=0&id=276d0848&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-276d0848"]])

export default __exports__